// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_a7-0";
export var orangeButton = "_a7-1";